import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { FirebaseService } from '../../services/firebase.service';
import { GetDataService } from '../../services/getdata.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ComponentType, HseType, LabOperationType, OperationType, QualityCheckNewType, WarehouseType } from '../../enums/enum.type';
import { CookieService } from 'ngx-cookie-service';
import { CommonService } from '../../services/common.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.css']
})
export class TopBarComponent implements OnInit {

  selectedProfile :"Admin"|"Verifier"="Verifier";
  operationType:OperationType = OperationType.Qualification;
  warehouseType:WarehouseType = WarehouseType.Warehouse;
  OperationType = OperationType;
  WarehouseType = WarehouseType;
  showProgressFilter = false;
  componentType = ComponentType.dashboard;
  ComponentType = ComponentType;
  LabOperationType = LabOperationType;
  labOperationType:LabOperationType = LabOperationType.Summary;

  qualityType:QualityCheckNewType = QualityCheckNewType.Dashboard;
  hseType:HseType = HseType.Dashboard;
  HseType = HseType;
  QualityCheckNewType = QualityCheckNewType;

  hasHseSummaryAccess = false;
  hasHseReportAccess = false;
  
  constructor(private firebaseService:FirebaseService,private getDataService: GetDataService,
    private router:Router,private ngxService:NgxUiLoaderService,private cookieService:CookieService,
    private commonService:CommonService) {
    this.getDataService.getUsername().subscribe(response=>{
      if(response){
        this.username = response;
      }
    });
    this.getDataService.componentType.subscribe(response=>{
      this.componentType=response;
      if(this.componentType == ComponentType.deployment){
        this.operationType = OperationType.Deployment;
      }
      else if(this.componentType == ComponentType.farmApp){
        this.operationType = OperationType.Qualification;
      }
      else if(this.componentType == ComponentType.engagement){
        this.operationType = OperationType.Engagement;
      }
      else if(this.componentType == ComponentType.summary){
        this.labOperationType = LabOperationType.Summary;
      }
      else if(this.componentType == ComponentType.samples){
        this.labOperationType = LabOperationType.Samples;
      }
      else if(this.componentType == ComponentType.carts){
        this.labOperationType = LabOperationType.Carts;
      }
      else if(this.componentType == ComponentType.shipments){
        this.labOperationType = LabOperationType.Shipments;
      }
      else if(this.componentType == ComponentType.conversation){
        this.operationType = OperationType.Conversation;
      }
      else if(this.componentType == ComponentType.warehouseApp){
        this.warehouseType = WarehouseType.Warehouse;
      }
      else if(this.componentType == ComponentType.warehouseDashboard){
        this.warehouseType = WarehouseType.Dashboard;
      }
      else if(this.componentType == ComponentType.qualityCheck){
        this.warehouseType = WarehouseType.QualityCheck;
      }
      else if(this.componentType == ComponentType.supplyDemand){
        this.supplyDemandType = 'SupplyDemand';
      }
      else if(this.componentType == ComponentType.Planning){
        this.supplyDemandType = 'PlanVsActual';
      }
      else if(this.componentType == ComponentType.qualityCheckNew){
        this.qualityType =QualityCheckNewType.Dashboard;
      }
      else if(this.componentType == ComponentType.qualityDefect){
        this.qualityType = QualityCheckNewType.Defects;
      }
      else if(this.componentType == ComponentType.qualitySource){
        this.qualityType = QualityCheckNewType.Sources;
      }
      else if(this.componentType == ComponentType.hseDashboard){
        this.hseType = HseType.Dashboard;
      }
      else if(this.componentType == ComponentType.hseReport){
        this.hseType = HseType.Report;
      }
    })

    const hseSummaryAccess = localStorage.getItem('hse_summary_access') || false;
    const hseReportAccess = localStorage.getItem('hse_report_access') || false;
    this.hasHseSummaryAccess = hseSummaryAccess == 'true';
    this.hasHseReportAccess = hseReportAccess == 'true';
   }

  ngOnInit(): void {
  }

  username = "";


  setOperationType =(operationType :OperationType)=>{
    this.operationType = operationType;
    if(this.operationType == OperationType.Qualification){
      this.router.navigateByUrl("/farm/qualification");
    }
    else if(this.operationType === OperationType.Deployment){
      this.router.navigateByUrl("/farm/deployment");
    }
    else if(this.operationType == OperationType.Engagement){
      this.router.navigateByUrl("/farm/engagement");
    }
    else{
      this.router.navigateByUrl("/farm/conversation");
    }
  }

  supplyDemandType:'SupplyDemand'|'PlanVsActual' = 'SupplyDemand';
  setSupplyDemand(type:'SupplyDemand'|'PlanVsActual'){
    this.supplyDemandType = type;
    if(this.supplyDemandType == 'SupplyDemand'){
      this.router.navigateByUrl("/supply");
    }
    else{
      this.router.navigateByUrl("/supply/planning");
    }
  }

  setWarehouseType =(warehouseType:WarehouseType)=>{
    this.warehouseType = warehouseType;
    if(this.warehouseType == WarehouseType.Warehouse){
      this.router.navigateByUrl("/warehouse");
    }
    else if(this.warehouseType == WarehouseType.Dashboard){
      this.router.navigateByUrl("/warehouse/dashboard");
    }
    else{
      this.router.navigateByUrl("/warehouse/quality-check");
    }
  }

  setHseType=(hseType:HseType)=>{
    this.hseType = hseType;
    if(this.hseType == HseType.Dashboard){
      this.router.navigateByUrl("/hse");
    }
    else{
      this.router.navigateByUrl("/hse/report");
    }
  }

  setQualityCheckType=(type:QualityCheckNewType)=>{
    this.qualityType = type;
    if(this.qualityType == QualityCheckNewType.Dashboard){
      this.router.navigateByUrl("/quality-check");
    }
    else if(this.qualityType == QualityCheckNewType.Defects){
      this.router.navigateByUrl("/quality-check/defects-report");
    }
    else{
      this.router.navigateByUrl("/quality-check/sources");
    }
  }

  setLabOperationType=(operationType:LabOperationType)=>{
    this.labOperationType = operationType;

    if(this.labOperationType == LabOperationType.Summary){
      this.getDataService.componentType.next(ComponentType.summary);
      // this.router.navigateByUrl("/lab/summary");
    }
    else if(this.labOperationType == LabOperationType.Samples){
      this.getDataService.componentType.next(ComponentType.samples);
      // this.router.navigateByUrl("/lab/samples");
    }
    else if(this.labOperationType == LabOperationType.Carts){
      this.getDataService.componentType.next(ComponentType.carts);
      // this.router.navigateByUrl("/lab/carts");
    }
    else{
      this.getDataService.componentType.next(ComponentType.shipments);
      // this.router.navigateByUrl("/lab/shipments");
    }
  }

  onLogout = () =>{
    try {
      this.ngxService.start();
      this.firebaseService.logout()
        .then(()=>{
          // on logout
          localStorage.clear();
          this.cookieService.deleteAll();
          this.router.navigateByUrl("/auth/login");
        })
        .catch(error=>{
          const errorCode = error.code;
          const errorMessage = error.message;
          console.log('error',error);
        })
        this.ngxService.stop();
    } catch (error:any) {
      const errorCode = error.code;
      const errorMessage = error.message;
      console.log('error',error);
      this.ngxService.stop();
    }
  }
  
  onSwitchProfile(profile:'Admin'|'Verifier'){
     this.selectedProfile = profile;
     if(profile == 'Admin'){
       // do nothing
       // redirect to admin app... an external link on same tab
       window.open(environment.adminUrl,'_self');
     }
     else{
       // switch to verifier app...
     }
   }
}
